
export default function (element, data) {
    const select = element.querySelector("select.input-field");

    element.addEventListener("change", function () {
        if (select.value && select.value.length > 0) {
            select.classList.add("not-empty");
            select.classList.remove("empty");
        } else {
            select.classList.add("empty");
            select.classList.remove("not-empty");
        }
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary